export const icons = [
  {
    iconType: "editStatus",
    icon: "status", // It should match the name of the icon in the assets/icons
    toolTip: {
      required: true,
      text: "Edit Status",
      placement: "top",
    },
    actionType: "Popover",
    Popover: {
      action: "statusChange",
    },
    isGrey: false, // Do we need to grey this icon when two or more rwos are selected
    greyIcon: "status-disabled",
  },
  {
    iconType: "editAssignee",
    icon: "reassign-active",
    toolTip: {
      required: true,
      text: "Edit Assignee",
      placement: "top",
    },
    actionType: "Popover",
    Popover: {
      action: "assignTo",
    },
    isGrey: false,
    greyIcon: "reassign-inactive",
  },
  {
    iconType: "editDuedate",
    icon: "calendar",
    toolTip: {
      required: true,
      text: "Edit Due Date",
      placement: "top",
    },
    actionType: "Popover",
    Popover: {
      action: "dueDate",
    },
    isGrey: false,
    greyIcon: "calendar-inactive",
  },
  {
    iconType: "editJob",
    icon: "edit",
    toolTip: {
      required: true,
      text: "Edit Job",
      placement: "top",
    },
    actionType: "clickHandler", // We will add it later,
    isGrey: true,
    greyIcon: "edit-disabled",
  },
  {
    iconType: "addQC",
    icon: "QC",
    warningIcon: "QC-red",
    successIcon: "QC-green",
    toolTip: {
      required: true,
      text: "Add/Remove QC",
      placement: "top",
    },
    actionType: "clickHandler",
    isChecked: false,
    unCheckedIcon: "QC-disabled",
  },
  {
    iconType: "delete",
    icon: "delete", // It should match the name of the icon in the assets/icons
    toolTip: {
      required: true,
      text: "Delete Job",
      placement: "top",
    },
    actionType: "clickHandler",
    isGrey: true, // Do we need to grey this icon when two or more rwos are selected
    greyIcon: "delete-disable",
  },
  {
    iconType: "sourceOverride",
    icon: "source",
    warningIcon: "source-red",
    successIcon: "source-green",
    toolTip: {
      required: true,
      text: "Source Override",
      placement: "top",
    },
    actionType: "clickHandler",
    isChecked: false,
    unCheckedIcon: "source-disabled",
  },
  {
    iconType: "qcList",
    icon: "list",
    toolTip: {
      required: true,
      text: "QC CheckList",
      placement: "top",
    },
    actionType: "Popover",
    Popover: {
      action: "qcList",
    },
  }
];
